import { ReducerBuilder } from "redux-ts-simple";
import { ScrollActions } from "../actions/action";

const reducer = new ReducerBuilder({ hash: ''})
  .on(ScrollActions.setHash, (state, action) => ({ ...state, hash: action.payload }))
  .on(ScrollActions.reset, (state, action) => ({ ...state, hash: '' }))
  .on(ScrollActions.setParentPage, (state, action) => ({ ...state, parentPage: action.payload }))
  .build();



export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/reducer.js